import { Pipe, PipeTransform } from "@angular/core";

const FORUM_REACTION_EMOJI_MAP: Record<string, string> = {
  like: "👍",
  heart: "❤️",
  dislike: "👎",
  fire: "🔥",
  muscle: "💪",
  eyes: "👀",
  clap: "👏",
  bangbang: "‼️",
  question: "❓",
};

@Pipe({
  name: "forumReactionEmoji",
})
export class ForumReactionEmojiPipe implements PipeTransform {
  transform(code?: string | null): string {
    if (!code) {
      return "❔";
    }

    return FORUM_REACTION_EMOJI_MAP[code] || code;
  }
}
